<template>
  <div>
    <div class='recent-match-cell' v-if="recentMatch">
      <div id='time'>{{ startTime }}</div>
      <div>
        <div>
          <div class='team-score-board'>
            <div :class='teamScore > opponentScore ? "win" : ""'>{{ teamScore }}</div>
            <div>-</div>
          </div>
          <div class='team-score-board'>
            <div :class='opponentScore > teamScore ? "win" : ""'>{{ opponentScore }}</div>
            <div>{{ $t(`teamName.${recentMatch.opponent}`) }}</div>
          </div>
        </div>
        <div>{{ recentMatch.duration }}</div>
        <div>{{ recentMatch.rebound }}</div>
        <div>{{ recentMatch.assists }}</div>
        <div>{{ recentMatch.steal }}</div>
        <div>{{ recentMatch.blockShots }}</div>
        <div>{{ recentMatch.point }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateConverter } from '@/utils'

export default {
  name: 'recent-match-cell',
  props: {
    recentMatch: {
      type: Object,
      required: true
    }
  },
  computed: {
    opponentScore () {
      return this.recentMatch.isHomeTeam === 1 ? this.recentMatch.awayScore : this.recentMatch.homeScore
    },
    teamScore () {
      return this.recentMatch.isHomeTeam === 1 ? this.recentMatch.homeScore : this.recentMatch.awayScore
    },
    startTime () {
      return dateConverter(this.recentMatch.gameDate).slice(5, 10)
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../styles'

.recent-match-cell
  padding: 5px 15px
  min-height: 64px

  > div:nth-child(2) // cell row 2
    display: flex
    justify-content: center
    text-align: center
    font-size: 12px
    color: #333333

    > div:first-child // match block
      width: vw(129)

    > div:nth-child(n+2) // all stats
      margin-top: auto
      margin-bottom: auto

    > div:not(:last-child)
      margin-right: 5px

    > div:nth-child(n+3)
      width: vw(31)

    > div:nth-child(2) // match time
      width: vw(36)

#time
  font-size: 10px
  color: #999999
  margin-bottom: 10px

.team-score-board
  display: flex
  $textPadding: 3px

  > div:nth-child(1) // score
    background-color: #eff0f3
    width: vw(24)
    margin-right: 5px
    padding: $textPadding
    font-weight: bold
    position: relative
    top: -$textPadding

  > div:nth-child(2)  // team name
    justify-content: center
    align-items: center

  &:nth-child(1) // curretn team
    margin-bottom: 2px

.win
  color: #ff5a5e
</style>
